/** @jsxRuntime classic */
/** @jsx jsx */
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import useLink from '../../useLink';
import { ListRow, ListRowBody } from '../List';
import ProducerHeader from '../Producer/ProducerHeader';
import DistributionContacts from './BrandContacts/DistributionContacts';
import BrandLogo from './BrandLogo';

export default function PresentedBrand({ brand, ...rest }) {
  const link = useLink();
  return (
    <ListRow {...rest} to={link.producer(brand)} sx={{ boxShadow: '' }}>
      {brand.logo && (
        <BrandLogo
          brand={brand}
          sx={{ margin: 3, marginRight: 0, position: 'relative' }}
        />
      )}
      <ListRowBody sx={{ position: 'relative', padding: undefined }}>
        <ProducerHeader producer={brand} />
        <DistributionContacts brand={brand} />
      </ListRowBody>
    </ListRow>
  );
}

export const fragment = graphql`
  fragment PresentedBrand on Bottlebooks_RegisteredBrand {
    name
    nameWithoutPrefixAndSuffix: name # TODO Fix
    ...bb_DistributionContacts
    ...useLink_bb_RegisteredBrand
  }
`;
